import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMergeConflict: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="merge-conflict"><circle cx="6" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="18" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6 10.75V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M10.75 6H18V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4 4L8 8M8 4L4 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMergeConflict;
